import * as types from "./types";
import Cookies from "js-cookie";

const mutations = {
  [types.SET_BODY_COLORS](state, payload) {
    // save in store
    state.bodyColors = payload;
  },
  [types.SET_HEADER_COLORS](state, payload) {
    // save in store
    state.headerColors = payload;
  },
  [types.SET_FOOTER_COLORS](state, payload) {
    // save in store
    state.footerColors = payload;
  },
  [types.SET_CARD_COLORS](state, payload) {
    // save in store
    state.cardColors = payload;
  },
  [types.SET_SIDEBAR_COLORS](state, payload) {
    // save in store
    state.sidebarColors = payload;
  }
};

export default mutations;
